import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import useStyles from './styles';

const Loading = () => {
  const classes = useStyles();
  return (
    <div className={classes.iconWrapper}>
      <FontAwesomeIcon icon={faSpinner} pulse />
    </div>
  );
};

export default Loading;
